namespace $.$$ {
	$mol_style_define($shm_hitalama_benchmarks_page_metrics_delete, {
		Trigger: { padding: { top: '0.25rem', bottom: '0.25rem', left: '0.5rem', right: '0.5rem' }, minHeight: '2rem' },
		Content: { alignItems: 'center' },
	})
}
